import {Component, OnInit, Optional, ChangeDetectionStrategy} from '@angular/core';
import { NgClass } from "@angular/common";
import {InputSwitchComponent} from '../../../layout/input-switch/input-switch.component';
import {PartnerTabComponent} from '../partner-tab/partner-tab.component';
import {Partner} from '../../../../models/partner/partner';
import {LoaderService} from '../../../../services/loader/loader.service';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MetaTitle} from '../../../../decorator/meta-title';
import {PartnerService} from '../../../../services/partner/partner.service';
import {PartnerOfferService} from '../../../../services/partner-offer/partner-offer.service';
import {TableSorter} from '../../../../tools/table-sorter/table-sorter';
import {Paginator} from '../../../../tools/pagination/paginator';
import {PartnerOffer} from '../../../../models/partner/partner-offer';
import {Offer} from '../../../../models/offer';
import {OfferService} from '../../../../services/offer/offer.service';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {ConfirmDirective} from '../../../../directives/confirm/confirm.directive';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {TableSorterHeaderDirective} from '../../../../directives/table-sorter/table-sorter-header.directive';
import {TableSorterDirective} from '../../../../directives/table-sorter/table-sorter.directive';

@Component({
  selector: 'app-partner-offer',
  imports: [
    InputSwitchComponent,
    FormsModule,
    ReactiveFormsModule,
    PaginatorComponent,
    NgClass,
    ConfirmDirective,
    TableSorterHeaderDirective,
    TableSorterDirective
],
  templateUrl: './partner-offer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-offer.component.scss'
})
@MetaTitle('Offers')
export class PartnerOfferComponent implements OnInit {

  partner: Partner | null = null;
  partnerOffers: PartnerOffer[] = [];
  offers: Offer[] = [];

  tableSorter: TableSorter = new TableSorter('subid', 'asc');
  paginator: Paginator = new Paginator();

  form = new FormGroup({
    subid: new FormControl(''),
    offer: new FormControl<Offer | null>(null, Validators.required)
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private partnerService: PartnerService,
    private partnerOfferService: PartnerOfferService,
    private offerService: OfferService,
    @Optional() private partnerTab: PartnerTabComponent
  ) {
  }

  ngOnInit(): void {
    this.offerService.findAll().subscribe((offers) => {
      this.offers = offers;
    });

    this.partnerTab.partnerSubject.subscribe((partner: Partner | null) => {
      this.partner = partner;
      if (this.partner) {
        this.fetchAll();
      }
    });
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.partnerOfferService.findAll({partnerId: this.partner?.id}, this.paginator, this.tableSorter).subscribe((partnerOffers) => {
      this.partnerOffers = partnerOffers;
      this.loader.stopLoading();
    });
  }

  onChangeAccess(e: any): void {
    if (!this.partner?.id) {
      return;
    }

    this.partner.allOffersAccess = e.target.checked;

    this.loader.startLoading();
    this.partnerService.update(this.partner.id, {
      allOffersAccess: this.partner.allOffersAccess
    }).subscribe(() => {
      if (this.partner?.allOffersAccess) {
        this.snackbar.success('Access to all offers has been approved');
      } else {
        this.snackbar.success('Access to all offers has been unapproved');
      }
      this.loader.stopLoading();
    });
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    const params = this.form.value;

    if (params.offer?.id) {
      this.loader.startLoading();
      this.partnerOfferService.create({
        partnerId: this.partner?.id,
        subid: params.subid,
        offerId: params.offer.id,
        status: 'active'
      }).subscribe(() => {
        this.snackbar.success('Offer has been created');
        this.fetchAll();
      });
    }
  }

  onChangeStatus(partnerOffer: PartnerOffer, status: string): void {
    if (!partnerOffer.id) {
      return;
    }

    this.loader.startLoading();
    this.partnerOfferService.update(partnerOffer.id, {status}).subscribe(() => {
      partnerOffer.status = status;
      this.snackbar.success('Status has been updated');
      this.loader.stopLoading();
    });
  }

  delete(partnerOffer: PartnerOffer): void {
    if (partnerOffer.id) {
      this.loader.startLoading();
      this.partnerOfferService.delete(partnerOffer.id).subscribe(() => {
        this.snackbar.success('Offer has been deleted');
        this.fetchAll();
      });
    }
  }
}
